export class Counter {
  id: number;
  etudiant: number;
  diplome: number;
  prix: number;
  partenaire: number;
}
